module.exports = __webpack_public_path__ + "img/alexis.cb7fde75.jpg";